import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues } from '../../public/utility'
import { doGetGiveVacationApply, doSaveGiveVacationApply } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import TreeSelect from '../../business/TreeSelect'

class GiveVacationApplyDetail extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetGiveVacationApply(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetGiveVacationApply = (id) => {
        const { dispatch } = this.props
        dispatch(doGetGiveVacationApply({
            id: id || 0,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, onSave, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        dispatch(doSaveGiveVacationApply({
            id,
            changedValues基本信息,
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.doGetGiveVacationApply(id)
                }
            }
        }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onRefresh, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteGiveVacationApply',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.depid && values.员工姓名
            && values.假勤项目 && ((values.假勤项目 == '婚假' && values.领证日期 && values.领证日期 != nullDate && values.请假开始时间 && values.请假开始时间 != nullDate) ||
                (values.假勤项目 == '丧假' && values.与丧亡人关系 && values.死亡日期 && values.死亡日期 != nullDate) ||
                (values.假勤项目 == '产假' && values.产假类型 && values.胎数 && values.开始日期 && values.开始日期 != nullDate) ||
                (values.假勤项目 == '住院病假' && values.开始日期 && values.开始日期 != nullDate) ||
                (values.假勤项目 == '陪产假' && values.开始日期 && values.开始日期 != nullDate) ||
                (values.假勤项目 == '哺乳假' && values.婴儿出生日 && values.婴儿出生日 != nullDate) ||
                (['婚假', '丧假', '产假', '住院病假', '陪产假', '哺乳假'].indexOf(values.假勤项目) == -1) &&
                values.时长 && values.生效日期 && values.生效日期 != nullDate && values.有效期 && values.有效期 != nullDate)
    }

    fieldset基本信息 = () => {
        const { id } = this.state
        const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
        const 产假类型 = getFormValue(this, '基本信息', '产假类型')
        const depid = getFormValue(this, '基本信息', 'depid')
        const { optionsParas } = this.state
        const { list: optionsList } = getListFromValues('部门名称', null, optionsParas.obj部门, {})
        const bRequired = ['婚假', '丧假', '产假', '住院病假', '陪产假', '哺乳假'].indexOf(假勤项目) == -1
        const bType=['妊娠未满4个月流产','妊娠满4个月流产'].indexOf(产假类型) == -1

        return [
            { _text: '记录编号', minWidth: '45%', disabled: true },
            { _date: '创建日期', minWidth: '45%', disabled: true },
            {
                _treeselect: '部门名称', name: 'depid', required: true, minWidth: '30%', displayField: '部门名称', options: optionsList,
                displayFull: '/', displayName: 'fullName', fullNameField: 'fullName', leafOnly: false, rootText: '',
            },
            { _select: '员工姓名', optionName: `${depid}_员工姓名`, minWidth: '90%', required: true, multiSelect: true,editable: true, forceSelection: false,  },  
            { _select: '假勤项目', minWidth: '45%', required: true, editable: true, forceSelection: false },
            { _date: '领证日期', minWidth: '45%', cdt: () => 假勤项目 == '婚假', required: true },
            { _date: '请假开始时间', minWidth: '45%', cdt: () => 假勤项目 == '婚假', required: true },
            { _select: '与丧亡人关系', minWidth: '45%', cdt: () => 假勤项目 == '丧假', required: true },
            { _date: '死亡日期', minWidth: '45%', cdt: () => 假勤项目 == '丧假', required: true },
            { _select: '产假类型', minWidth: '45%', cdt: () => 假勤项目 == '产假', required: true },
            { _int: '胎数', minWidth: '45%', cdt: () => 假勤项目 == '产假' && 产假类型 != '妊娠未满4个月流产' && 产假类型!='妊娠满4个月流产' , required: true },
            { _date: '开始日期', minWidth: '45%', cdt: () => 假勤项目 == '住院病假' || 假勤项目 == '陪产假' || 假勤项目 == '产假', required: true },
            { _date: '婴儿出生日', minWidth: '45%', cdt: () => 假勤项目 == '哺乳假', required: true },
            { _text: '备注', minWidth: '90%', maxRows: 4, },
            { _files: '附件', minWidth: '90%', },
            { _float: '充值时长（小时）', name: '时长', minWidth: '25%', required: bRequired  /* disabled: true, cdt: () => id > 0 */ },
            { _datetime: '生效日期', minWidth: '35%', required: bRequired /* disabled: true, cdt: () => id > 0  */ },
            { _datetime: '有效期', minWidth: '35%', required: bRequired /* cdt: () => id > 0 */ },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete, disabled: this.bChanged() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '给假登记', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]
            }
        />
    }
}

export default connect()(GiveVacationApplyDetail)